import { render, staticRenderFns } from "./DisplaySetting.vue?vue&type=template&id=77b07cf0&"
import script from "./DisplaySetting.vue?vue&type=script&lang=js&"
export * from "./DisplaySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports